import { createWebHistory, createRouter } from "vue-router";
import Login from "@/views/LoginView.vue";
import Upload from "@/views/UploadView.vue";
import Results from "@/views/ResultsView.vue";
import Download from "@/views/DownloadView.vue";
import { getAuth } from "firebase/auth";


const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
  },
  {
    path: "/upload",
    name: "Upload",
    component: Upload,
    meta: { requiresAuth: true },
  },
  {
    path: "/results",
    name: "Results",
    component: Results,
    meta: { requiresAuth: true },
  },
  {
    path: "/download",
    name: "Download",
    component: Download,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = getAuth().currentUser;
  if (requiresAuth && !isAuthenticated) {
    if (to.name !== 'Login') {
      next('/');
    } else {
      next(); // Allow navigation to the login page
    }
  } else {
    next();
  }
});

export default router;